<template>
  <div class="panel">
    <a
      class="panel-block"
      v-for="gps in gpsDevices"
      :key="gps.deviceId || gps.imei"
      @click="gpsSelected(gps)"
      :class="{
        'has-background-grey-dark': isSelectedGPS(gps),
        'has-text-light': isSelectedGPS(gps)
      }"
    >
      <span class="panel-icon">
        <i
          class="icon-compass has-text-weight-bold"
          :class="{ 'has-text-light': isSelectedGPS(gps) }"
          aria-hidden="true"
        ></i>
      </span>

      <div class="container">
        <span class="is-pulled-left" v-if="gps.deviceId">{{ gps.deviceId }}_GPS</span>
        <span class="is-pulled-left" v-else>{{ gps.imei }}</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'GPSSearchResultList',

  props: {
    gpsDevices: {
      type: Array,
      default: () => []
    },

    selectedIMEI: {
      type: String
    },

    selectedDeviceId: {
      type: String
    }
  },

  computed: {},

  methods: {
    gpsSelected(gps) {
      this.$emit('gps-selected', gps)
    },

    isSelectedGPS(gps) {
      if (!this.selectedIMEI && !this.selectedDeviceId) {
        return false
      }

      return this.selectedIMEI === gps.imei || this.selectedDeviceId === gps.deviceId
    }
  }
}
</script>

<style lang="scss" scoped>
.panel {
  min-width: 300px;
}
</style>
